import makeQuery, {descripcionFormatter} from "../../../api/helper";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    isLoading: false,
    productos: [],
    carro: [],
    carroPaso: [],
    filtros: {
      sucursal: "",
      proveedor: "",
      categoria: "",
      codigo: "",
      grupo: "",
      descripcion: ""
    },
    detalleProducto: [],
    limite: 28,
    offset: 0,
    currentPage: 1,
    total: 0,
    totalGrupo: [],
  },
  mutations: {
    "SET_PRODUCTOS"(state, payload) {
      state.productos = payload
    },
    "ADD_PRODUCT"(state, payload) {
      state.carro.push(payload)
    },
    "REMOVE_PRODUCT"(state, payload) {
      state.carro.splice(payload, 1)
    },
    "REMOVE_All"(state, payload) {
      state.carro = payload
    },
    "SET_FILTRO"(state, payload) {
      state.filtros[payload.key] = payload.data
    },
    "IS_LOADING"(state, payload) {
      state.isLoading = payload
    },
    "MODIFY_CANTIDAD_COMPRA"(state, payload) {
      state.carro[payload.index].cantidad_a_comprar = payload.cantidad
    },
    "SET_DETALLE_PRODUCTO"(state, payload) {
      state.detalleProducto = payload
    },
    "NEXT_PAGE"(state) {
      state.currentPage++
      state.offset = state.limite * (state.currentPage - 1)
    },
    "BACK_PAGE"(state) {
      state.currentPage--
      state.offset = state.limite * (state.currentPage - 1)
    },
    "RESET_PAGES"(state) {
      state.currentPage = 1
      state.limite = 28
      state.offset = 0
    },
    "SET_TOTALES"(state, {total, total_grupo}) {
      state.total = total
      state.totalGrupo = total_grupo
    }
  },
  actions: {
    async getTotales({commit, dispatch, state}) {
      const newFiltros = await dispatch("crearFiltros")
      const query = makeQuery({filtros: newFiltros})
      const {data} = await this._vm.$axios.get(`compras/sugerido-compra/total${query}`)
      commit('SET_TOTALES', data)
    },
    async getProductosSugerido({commit, dispatch, state}) {
      commit("IS_LOADING", true)
      const newFiltros = await dispatch("crearFiltros")
      console.log(newFiltros)
      const query = makeQuery({filtros: newFiltros, limite: state.limite, offset: state.offset})
      this._vm.$axios.get(`compras/sugerido-compra${query}`)
        .then(({data}) => {
          commit("SET_PRODUCTOS", data.items.map(item => {
            return {...item, proveedor: item.proveedor.toUpperCase()}
          }))
          commit("IS_LOADING", false)
        })
        .catch(error => {
          console.error(error)
          this._vm.$swal("Error", error.response, "error")
          commit("IS_LOADING", false)
          commit("SET_PRODUCTOS", [])
        })
    },
    sendItemsToCar({commit, state}, payload) {
      const producto = state.carro.find(item => item.producto_id === payload.producto_id)
      const productoProveedor = state.carro.find(item => item.proveedor.toUpperCase() !== payload.proveedor.toUpperCase())
      if (payload.cantidad_a_comprar === 0) return this._vm.$swal("Alerta!", "La cantidad a comprar no puede ser 0", "warning")
      if (state.filtros.proveedor === "") return this._vm.$swal("Alerta!", "Debe seleccionar un proveedor", "warning")
      if (productoProveedor !== undefined) return this._vm.$swal("Alerta!", `Debe agregar solo productos para un proveedor...`, "warning")
      if (producto !== undefined) return this._vm.$swal("Alerta!", "Producto ya ingresado...", "warning")
      commit("ADD_PRODUCT", payload)
      this._vm.$swal("Correcto", "producto agregado correctamente...", "success")
    },
    generarOrdenCompra({commit}) {
      commit("REMOVE_All", [])
      this._vm.$swal("Correcto!", "Orden de compra generada correctamente...", "success")
    },
    nextPage({commit, dispatch}) {
      commit("NEXT_PAGE")
      dispatch("getProductosSugerido")
      window.scrollTo({top: 0, behavior: "smooth"})
    },
    backPage({commit, dispatch, state}) {
      if (state.currentPage === 1) return
      commit("BACK_PAGE")
      dispatch("getProductosSugerido")
      window.scrollTo({top: 0, behavior: "smooth"})
    },
    resetPages({commit}) {
      commit("RESET_PAGES")
    },
    async removeItem({commit}, index) {
      const response = await this._vm.$swal({
        type: "warning",
        title: "¿Quitar producto del carro?",
        text: "¿Esta Seguro?",
        confirmButtonText: "Si!",
        cancelButtonColor: "red",
        showCancelButton: true,
        confirmButtonColor: "blue",
      })
      if (response.value !== true) return
      commit("REMOVE_PRODUCT", index)
    },

    async removeAll({commit}) {
      const response = await this._vm.$swal({
        type: "warning",
        title: "¿Quitar todos los productos del carro?",
        text: "¿Esta Seguro?",
        confirmButtonText: "Si!",
        showCancelButton: true,
        cancelButtonColor: "red",
        confirmButtonColor: "blue",
      })
      if (response.value !== true) return
      commit("REMOVE_All", [])
    },
    getDetalle({commit, rootGetters}, payload) {
      let allQuerys = []
      const sucursales = rootGetters.sucursales
      sucursales.forEach(item => allQuerys.push(
        this._vm.$axios.get("compras/sugerido-compra" + makeQuery({
          filtros: [
            {field: "codigo.value", value: payload.codigo, operator: "CONTAINS"},
            {field: "sucursalId", value: item.id, operator: "="},
          ]
        }))
      ))
      axios.all(allQuerys).then(
        axios.spread((...responses) => {
          let response = []
          responses.forEach(item => {
            response.push(item.data.items[0])
          })
          commit("SET_DETALLE_PRODUCTO", response)
        })
      ).catch(console.error)
    },
    crearFiltros({state}) {
      let filtros = []
      Object.keys(state.filtros).forEach(item => {
        if (item === "sucursal" && state.filtros["sucursal"] !== "")
          filtros.push({field: "sucursalId", value: state.filtros["sucursal"].id, operator: "="})
        if (item === "proveedor" && state.filtros["proveedor"] !== "")
          filtros.push({field: "proveedor.value", value: state.filtros["proveedor"].nombre, operator: "CONTAINS"})
        if (item === "categoria" && state.filtros["categoria"] !== "")
          filtros.push({field: "categoriaId", value: state.filtros["categoria"].id, operator: "="})
        if (item === "codigo" && state.filtros["codigo"] !== "")
          filtros.push({field: "codigo.value", value: state.filtros["codigo"], operator: "CONTAINS"})
        if (item === "grupo" && state.filtros["grupo"] !== "")
          filtros.push({field: "grupo", value: state.filtros["grupo"], operator: "="})
        if (item === "descripcion" && state.filtros["descripcion"] !== "") {
          const descripcion = descripcionFormatter(state.filtros.descripcion)
          filtros.push(...descripcion)
        }
      })
      return filtros
    }

  },
  getters: {
    productosSugerido: state => state.productos,
    productosCarro: state => state.carro,
    isLoading: state => state.isLoading,
    currentPage: state => state.currentPage,
    detalleProducto: state => state.detalleProducto,
    total: ({total}) => total,
    totalGrupo: ({totalGrupo}) => totalGrupo
  }
}
